// Login.js
import React, { useState } from "react";
import axios from "../../api/axiosConfig";

function Login({ setUser }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/login", { email, password });
      const { token, user } = res.data;

      // 1) Token für axios-Interceptor setzen
      localStorage.setItem("token", token);

      // 2) Einladung einlösen: prefer Token -> sonst Fallback join
      const pendingBoardId = localStorage.getItem("pendingBoardId");
      const pendingInviteToken = localStorage.getItem("pendingInviteToken");
      if (pendingBoardId && pendingInviteToken) {
        try {
          await axios.post(`/invites/accept`, {
            boardId: Number(pendingBoardId),
            inviteToken: pendingInviteToken,
          });
        } catch (acceptErr) {
          console.error("Fehler beim Einlösen der Einladung:", acceptErr);
        } finally {
          localStorage.removeItem("pendingBoardId");
          localStorage.removeItem("pendingInviteToken");
        }
      } else if (pendingBoardId) {
        // Legacy/Fallback ohne Token
        try {
          await axios.post(`/boards/${pendingBoardId}/join`);
        } catch (joinErr) {
          console.error("Fehler beim automatischen Board-Join:", joinErr);
        } finally {
          localStorage.removeItem("pendingBoardId");
        }
      }

      // 3) App informieren -> Boards werden danach von App geladen
      setUser(user);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Login Fehler");
    }
  };

  return (
    <div className="auth-form">
      <h2>Login</h2>
      {error && <p className="form-error" role="alert">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        <button type="submit" className="btn btn-block">
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;
